((document, window) => {
    let requestAnimationFrame;

    // Get the top position of an element in the document
    const getTop = (element, start) => {
        // return value of html.getBoundingClientRect().top ... IE : 0, other browsers : -pageYOffset
        if (element.nodeName === 'HTML') return -start;
    
        const elementTop = element.getBoundingClientRect().top;
        const scrollMarginTop = parseInt((window.getComputedStyle(element).scrollMarginTop || 0).toString(), 10);
        return elementTop + start - scrollMarginTop;
    };

    /**
     * ease in out function
     * @see https://gist.github.com/gre/1650294
    **/
    easeInOutCubic = (t) => {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }
    const smoothScrollTo = function(scrollTo) {
      const duration = 500;
      const offset = -228;

      if (!requestAnimationFrame) {
          requestAnimationFrame = window.requestAnimationFrame ||
              function(fn) {
                  window.setTimeout(fn, 16);
              };
      }

      const startPoint = window.pageYOffset;
      // Get the top position of an element in the document
      // return value of html.getBoundingClientRect().top ... IE : 0, other browsers : -pageYOffset
      let end = getTop(scrollTo, startPoint);

      // Ajusts offset from the end
      end += offset;

      const clock = Date.now();
      const easeFn = easeInOutCubic;
      const step = () => {
          // the time elapsed from the beginning of the scroll
          const elapsed = Date.now() - clock;
          // calculate the scroll position we should be in
          let position = end;
          if (elapsed < duration) {
              position = startPoint + (end - startPoint) * easeFn(elapsed / duration);

              requestAnimationFrame(step);
          }

          window.scrollTo(0, position);
      };
      step();
    }

    const positionItemsAfterReviewsWidget = function () {
      const mainApp = document.querySelector('#app');
      const reviewsWidgetSection = document.querySelector('#oke-reviews-widget-section');
  
      const moveItemsAfterReviewsWidget = (el) => {
          const containerEl = document.createElement('div');
          containerEl.classList.add('container');
          reviewsWidgetSection.appendChild(containerEl);
          containerEl.appendChild(el);
      };
  
  
      if (mainApp && reviewsWidgetSection) {
          const appendAfterReviewsElements = document.querySelectorAll('[data-oke-append-after-reviews]');
          appendAfterReviewsElements.forEach(el => moveItemsAfterReviewsWidget(el));
  
          const callback = function (mutationList) {
              for (const mutation of mutationList) {
                  mutation.addedNodes.forEach((n) => {
                      if(n.nodeType === 1 && n.hasAttribute('data-oke-append-after-reviews')) {
                          moveItemsAfterReviewsWidget(n);
                      }
                  });
              }
          };
          const observer = new MutationObserver(callback);
          observer.observe(mainApp, { childList: true, subtree: true });
      }
    }

    const handleDocumentLoaded = function (e) {
        positionItemsAfterReviewsWidget();
        const okendoStarRatingElements = document.querySelectorAll('[data-oke-star-rating]');
        const okendoReviewsWidgetElement = document.querySelector('[data-oke-widget]');
        if (okendoStarRatingElements && okendoReviewsWidgetElement) {
           Array.from(okendoStarRatingElements).forEach(starRating => {
                 if (!starRating.querySelector('.oke-is-clickable')) {
                   starRating.style.cursor = 'pointer';
                   starRating.addEventListener('click', function(event) {
                      event.preventDefault();
                      smoothScrollTo(okendoReviewsWidgetElement);
                  }); 
                }
            });
        }
    }

    if (document.readyState !== 'interactive' && document.readyState !== 'complete') {
        document.addEventListener('readystatechange', () => {
            handleDocumentLoaded();
        }, { once: true });
    }
    else {
        handleDocumentLoaded();
    }
})(document, window);
